<template>
  <div class="">
    <div class="mgb80">
      <div class="content-web">
        <div class="inner_content_right">
          <div class="wp_single wp_column_article">
            <div class="wp_entry">
              <div class="wp_articlecontent">
                <div class="head">
                  <div class="lsd">天津燕园国际大酒店有限责任公司</div>
                  <p class="p1">
                    天津燕园国际大酒店是集商务，住宿，餐饮，休闲等为一体的豪华绿洲花园酒店。酒店环境郁郁葱葱，繁花盛草，宛如置身于绿洲之中。
                  </p>
                  <p class="p1">
                    从酒店出发到天津滨海国际机场仅需30分钟，到首都北京则仅需要2小时的车程。共设有296间不同类型的客房，并设有中，西餐厅，咖啡厅和酒吧。以及可同时容纳500位客人的大宴会厅。
                  </p>
                  <div class="p1">
                    此外，酒店，室内游泳池，康体中心等娱乐健身设施。
                  </div>
                  <div class="p1">客房：296间</div>
                  <div class="p1">
                    餐饮：JV
                    酒吧、天宝阁中餐厅、盘山西餐厅、露台咖啡厅、清太郎日本餐厅、大堂吧
                  </div>
                  <div class="p1">
                    会议、宴会厅：大型豪华宴会厅、多功能会议室、小型会议室
                  </div>
                  <div class="p1">
                    服务设施：健身中心、网球场、SPA水疗、出租车服务
                  </div>
                  <div class="img1">
                    <img src="@/assets/images/yygj1.png" alt="" height="450px" />
                  </div>

                  <div class="img1">
                    <img src="@/assets/images/yygj2.png" alt="" height="450px" width="476px"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  beforeDestroy() {},
  methods: {},
};
</script>
<style lang='scss' scoped>
.mgb80 {
  margin-bottom: 80px;
  margin-top: 30px;
  .content-web {
    display: flex;
    width: 100%;
    // min-width: 1200px;
    margin: 0 auto;
    .inner_content_right {
      // float: right;
      //   box-sizing: border-box;
      //   width: 960px;
      //   min-height: 600px;
      //   margin-left: 20px;
      //   background-color: #fff;
      .wp_single.wp_column_article {
        padding: 48px 40px 100px 40px;
      }
      .wp_entry {
        line-height: 2em !important;
        font-size: 14px !important;
        font-family: "宋体" !important;
        width: 100%;
        line-height: 1.7em;
        font-size: 13px;
        color: #333;
        overflow: hidden;;
        .head {
          border-bottom: 1px #444 dashed;
          height: 100%;
          .lsd {
            font-size: 20px;
            text-align: center;
            font-weight: 800;
            margin-bottom: 20px;
          }
          .p1 {
            text-indent: 35px;
            margin-bottom: 20px;
          }
          .p2 {
            text-indent: 35px;
            margin-bottom: 20px;
          }
          .img1 {
            text-align: center;
            margin-bottom: 20px;
          }
        }
      }
      .text {
        text-indent: 35px;
      }
      .ltd {
        float: right;
      }
    }
  }
}
</style>